import TextCopyright from "assets/locales/ja/TextCopyright.js"
import AgreementSelectionContents from "assets/locales/ja/AgreementSelectionContents.js"
import AgreementCardPersonalRelation from "assets/locales/ja/AgreementCardPersonalRelation.js"
import AgreementCardAdvertising from "assets/locales/ja/AgreementCardAdvertising.js"
import AgreementCardThirdParty from "assets/locales/ja/AgreementCardThirdParty"
import AgreementButton from "assets/locales/ja/AgreementButton.js"
import AgreementModalPersonalRelation from "assets/locales/ja/AgreementModalPersonalRelation.js"
import AgreementModalAdvertising from "assets/locales/ja/AgreementModalAdvertising.js"
import AgreementModalThirdParty from "assets/locales/ja/AgreementModalThirdParty"

import Tab from "assets/locales/ja/Tab.js"
import Snackbar from "assets/locales/ja/Snackbar.js"

export default {
  ...TextCopyright,
  ...AgreementSelectionContents,
  ...AgreementCardPersonalRelation,
  ...AgreementCardAdvertising,
  ...AgreementCardThirdParty,
  ...AgreementButton,
  ...AgreementModalPersonalRelation,
  ...AgreementModalAdvertising,
  ...AgreementModalThirdParty,
  ...Tab,
  ...Snackbar,
}
